(function () {
  var metafieldsData = null;

  function getVariantMetafields() {
    if (metafieldsData) return metafieldsData;
    var el = document.querySelector('[data-variantJSON-metafields]');
    if (!el) return null;
    try { metafieldsData = JSON.parse(el.textContent); } catch (e) {}
    return metafieldsData;
  }

  function escHtml(str) {
    var d = document.createElement('div');
    d.textContent = String(str);
    return d.innerHTML;
  }

  function buildLogos(logos) {
    return logos.map(function (logo) {
      return '<img src="' + escHtml(logo.src) + '" alt="' + escHtml(logo.alt || '') + '" '
        + 'width="64" height="64" loading="eager" class="v2-cert-logo-img">';
    }).join('');
  }

  function buildBenefits(benefits) {
    return benefits.map(function (benefit) {
      return '<span class="v2-slide-benefit">' + escHtml(benefit) + '</span>';
    }).join('');
  }

  var slideListenerAdded = false;

  // Show/hide overlay based on whether slide 0 is active.
  // The overlay floats on the carousel container so it appears over whatever
  // slide is visible — we hide it when the user swipes to a non-main slide.
  function setupSlideListener() {
    if (slideListenerAdded) return;
    if (typeof productSlider === 'undefined' || !productSlider) return;
    productSlider.on('slideChange', function () {
      var onFirst = productSlider.realIndex === 0;
      var bc = document.querySelector('[data-pdp-slide-benefits]');
      var cc = document.querySelector('[data-pdp-cert-logos]');
      // Only toggle visibility for containers that have content (not display:none ones)
      if (bc && bc.style.display !== 'none') bc.style.visibility = onFirst ? '' : 'hidden';
      if (cc && cc.style.display !== 'none') cc.style.visibility = onFirst ? '' : 'hidden';
    });
    slideListenerAdded = true;
  }

  function update() {
    var current = window.globalVariables
      && window.globalVariables.product
      && window.globalVariables.product.currentVariant;
    if (!current) return;

    var data = getVariantMetafields();
    var variantData = data && data[String(current.id)];

    var certContainer = document.querySelector('[data-pdp-cert-logos]');
    if (certContainer) {
      var logos = variantData && variantData.cert_logos;
      if (logos && logos.length) {
        certContainer.innerHTML = buildLogos(logos);
        certContainer.style.display = '';
        certContainer.style.visibility = '';
      } else {
        certContainer.style.display = 'none';
      }
    }

    var benefitsContainer = document.querySelector('[data-pdp-slide-benefits]');
    if (benefitsContainer) {
      var benefits = variantData && variantData.slide_benefits;
      if (benefits && benefits.length) {
        benefitsContainer.innerHTML = buildBenefits(benefits);
        benefitsContainer.style.display = '';
        benefitsContainer.style.visibility = '';
      } else {
        benefitsContainer.style.display = 'none';
      }
    }

    setupSlideListener();
  }

  document.addEventListener('variant:changed', update);

  // variant:changed fires during connectedCallback before Swiper initializes,
  // so the first setupSlideListener() call above finds productSlider===null.
  // global.js dispatches pdp:slider:ready immediately after productSlider is set.
  document.addEventListener('pdp:slider:ready', setupSlideListener);
})();
